export const textColors = {
    primary: '#7154D6'
};
